import { pageItemsClient } from "@core/clients";
import { HomeDataSection } from "@core/types";
import { useQuery, UseQueryOptions } from "@tanstack/react-query";
import { GET_HOME_PAGE_CACHE_EXPIRE_TIME_MS } from "../../config/constansts";

type Options = UseQueryOptions<HomeDataSection[] | null, any, HomeDataSection[] | null, any>;

const useGetHomePageQuery = (options?: Options) => {
  return useQuery(
    ['get-home'],
    async () => {
      return await pageItemsClient.getHome();
    },
    {
      retry: 2,
      staleTime: GET_HOME_PAGE_CACHE_EXPIRE_TIME_MS,
      cacheTime: GET_HOME_PAGE_CACHE_EXPIRE_TIME_MS,
      ...options,
    },
  );
};

export default useGetHomePageQuery;
